import React from 'react';
import './loader.css';

interface Props {
	color?: 'primary' | 'secondary' | 'error' | 'warning' | 'success' | 'grey';
	variant?: 'solid' | 'text' | 'outlined';
	thickness?: 'thin' | 'medium' | 'thick';
	size?: number;
}

function resolveRgbColorValueFromProp(color: string = 'primary'): {
	text: string;
	background: string;
	contrast: string;
	main: string;
} {
	switch (color) {
		case 'error':
			return {
				text: '238,2,2',
				main: '238,2,2',
				background: '238,2,2',
				contrast: '255,255,255',
			};
		case 'warning':
			return {
				text: '221,172,0',
				main: '255,211,0',
				background: '255,211,53',
				contrast: '255,255,255',
			};
		case 'success':
			return {
				text: '95,216,85',
				main: '95,216,85',
				background: '95,216,85',
				contrast: '255,255,255',
			};
		case 'grey':
			return {
				text: '63,63,64',
				main: '63,63,64',
				background: '63,63,64',
				contrast: '255,255,255',
			};
		case 'primary':
		default:
			return {
				text: '98,2,238',
				main: '98,2,238',
				background: '98,2,238',
				contrast: '255,255,255',
			};
	}
}

const Loader: React.FC<Props> = ({
	color = 'primary',
	variant,
	thickness = 'medium',
	size = 80,
}) => {
	const thicknessMultiplier =
		thickness === 'thin' ? 0.05 : thickness === 'medium' ? 0.1 : 0.2;
	const smallSize = size * 0.8;
	const lineWidth = size * thicknessMultiplier;
	const positionCenterOffset = (size - smallSize) / 2;
	const colorOptions = resolveRgbColorValueFromProp(color);
	const borderColor =
		variant === 'outlined' || variant === 'text'
			? colorOptions.main
			: colorOptions.contrast;

	return (
		<div className='lds-ring' style={{ width: size, height: size }}>
			<div
				style={{
					width: smallSize,
					height: smallSize,
					borderWidth: lineWidth,
					top: positionCenterOffset,
					left: positionCenterOffset,
					borderColor: `rgb(${borderColor}) transparent transparent transparent`,
				}}
			/>
			<div
				style={{
					width: smallSize,
					height: smallSize,
					borderWidth: lineWidth,
					top: positionCenterOffset,
					left: positionCenterOffset,
					borderColor: `rgb(${borderColor}) transparent transparent transparent`,
				}}
			/>
			<div
				style={{
					width: smallSize,
					height: smallSize,
					borderWidth: lineWidth,
					top: positionCenterOffset,
					left: positionCenterOffset,
					borderColor: `rgb(${borderColor}) transparent transparent transparent`,
				}}
			/>
			<div
				style={{
					width: smallSize,
					height: smallSize,
					borderWidth: lineWidth,
					top: positionCenterOffset,
					left: positionCenterOffset,
					borderColor: `rgb(${borderColor}) transparent transparent transparent`,
				}}
			/>
		</div>
	);
};

export default Loader;
